export default "__VITE_ASSET__7bb14240__"